<main class="menu info">
    <div id="background"></div>
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{_('menu_title')}}</h1>
            <span
                class="icon back"
                @click="app.code ? app.setPage('Terminal') : back()"
            >
                chevron_left
            </span>
        </div>
    </header>

    <div class="first">
        <div class="guest" @click="openGuestInformation(firstGuest)">
            <div class="guest_content">
                <div class="guest_title">
                    <span class="symbol">account_circle</span
                    >{{_('guest_title')}} ({{ _('title_representative')}})
                </div>
                <div v-if="firstGuest">
                    <p v-if="firstGuestName()">
                        {{_('honor', firstGuestName())}}
                        <span class="incomplete" v-if="!firstGuest.completed"
                            >※{{_('uncompleted_enter_guest_info')}}</span
                        >
                    </p>
                    <p v-else-if="firstGuest.completed">
                        {{_('completed_enter_guest_info')}}
                    </p>
                    <p v-else>{{_('guest_enter')}}</p>
                </div>
            </div>
            <div class="guest_arrow">
                <span class="icon">keyboard_arrow_right</span>
            </div>
        </div>
    </div>
    <template v-for="(guest, idx) in app.guestList">
        <div
            class="guest companion"
            @click="openGuestInformation(guest)"
            v-if="guest.id !== firstGuest.id"
        >
            <div class="guest_content">
                <div class="guest_title">
                    <span class="symbol">account_circle</span
                    >{{_('guest_title')}} ({{idx ? _('title_companion') :
                    _('title_representative')}})
                </div>
                <div>
                    <p v-if="guest.name">
                        {{_('honor', guest.name)}}
                        <span class="incomplete" v-if="!guest.completed"
                            >※{{_('uncompleted_enter_guest_info')}}</span
                        >
                    </p>
                    <p v-else-if="guest.completed">
                        {{_('completed_enter_guest_info')}}
                    </p>
                    <p v-else>{{ _('companion_enter') }}</p>
                </div>
            </div>
            <div class="guest_arrow">
                <span class="icon">keyboard_arrow_right</span>
            </div>
        </div>
    </template>

    <template v-if="app.line && app.getLang() === 'ja'">
        <hr />
        <div class="line-wrapper" @click="showLine = true">
            <div
                v-if="app.line.banner_image_url"
                class="image-container"
                style="height: 8rem"
            >
                <img :src="app.line.banner_image_url" />
            </div>
            <div v-else class="line-default-banner">
                <div class="left-box">
                    <h1>LINE</h1>
                    <h1>公式アカウント</h1>
                </div>
                <div class="right-box">
                    <h1>友だち追加で</h1>
                    <p>お得な特典いっぱい！</p>
                </div>
            </div>
        </div>
        <div class="shadow flex_centered" v-if="showLine">
            <line-modal
                :add-friends-url="app.line.add_friends_url"
                :appeal-text="app.line.appeal_text"
                :appeal-image-url="app.line.appeal_image_url"
                @close="showLine = false"
            ></line-modal>
        </div>
    </template>

    <hr />
    <div class="remarks">
        <pre>※ {{_('requesting_text')}}</pre>
    </div>
    <hr />
    <tab-bar :page="app.query.page"></tab-bar>
</main>
